import React, { useState, useEffect } from "react";
import { GridToolbar } from "@mui/x-data-grid-pro";
import { Button, Snackbar } from "@mui/material";
import SavedFreightItemDialog from "./dialogs/SavedFreightItemDialog";
import { decoratedFetch } from "../req_utils";
import { GENESIS_LOGO_COLOR } from "../constants";
import ThemedDataGridPro from "./ThemedDataGridPro";
import { useSelector } from "react-redux";

const columns = [
  { field: "freight_item_type", headerName: "Type", flex: 1 },
  { field: "description", headerName: "Description", flex: 1 },
  { field: "ship_from", headerName: "Ship From", flex: 1 },
  { field: "ship_to", headerName: "Ship To", flex: 1 },
  {
    field: "size_unit",
    headerName: "Unit",
    flex: 1,
    renderCell: (params) => {
      return params.value.name;
    },
  },
  {
    field: "unit_price",
    headerName: "Price",
    flex: 1,
  },
];

const SavedFreightItems = ({ value, index }) => {
  const employee_branch_id = useSelector((state) => state.employee_branch_id);
  const [selectedItem, setSelectedItem] = useState(null);
  const [open, setOpen] = useState(false);
  const [savedFreightItems, setSavedFreightItems] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [savedFreightItemsLoading, setSavedFreightItemsLoading] =
    useState(false);

  const listSavedFreightItems = () => {
    if (!employee_branch_id) return;
    
    decoratedFetch(`/list_saved_freight_items?branch_id=${employee_branch_id}`)
      .then((response) => {
        if (response.status !== 200) {
          throw new Error("Unknown error");
        }
        return response.json();
      })
      .then((data) => {
        setSavedFreightItemsLoading(false);
        setSavedFreightItems(data);
      })
      .catch((error) => {
        setSavedFreightItemsLoading(true);
        console.error(`Error fetching data: ${error}`);
      });
  };

  useEffect(() => {
    if (value !== index || !employee_branch_id) {
      return;
    }
    setSavedFreightItemsLoading(true);
    listSavedFreightItems();
  }, [employee_branch_id, value, index]);

  const handleRowClick = (params) => {
    setSelectedItem(params.row);
    setOpen(true);
  };

  const handleDialogClose = () => {
    setSelectedItem(null);
    setOpen(false);
    listSavedFreightItems(); // Refresh data
  };

  return (
    <div>
      <Snackbar
        sx={{
          ".MuiSnackbarContent-root": {
            backgroundColor: GENESIS_LOGO_COLOR,
            minWidth: 0,
          },
        }}
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          paddingBottom: 10,
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ margin: 5 }}
          onClick={() => setOpen(true)}
        >
          Create Freight Item
        </Button>
      </div>
      <div style={{ height: "auto", width: "100%" }}>
        <ThemedDataGridPro
          rows={savedFreightItems}
          slots={{ toolbar: GridToolbar }}
          columns={columns}
          onRowClick={handleRowClick}
          loading={savedFreightItemsLoading}
          localeText={{ noRowsLabel: "No freight items" }}
          sx={{
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cellCheckbox:focus, & .MuiDataGrid-cellCheckbox:focus-within":
              {
                outline: "none",
              },
          }}
        />
      </div>
      <SavedFreightItemDialog
        isOpen={open}
        freightItem={selectedItem}
        handleClose={handleDialogClose}
        setSnackbarOpen={setSnackbarOpen}
        setSnackbarMessage={setSnackbarMessage}
      />
    </div>
  );
};

export default SavedFreightItems;
